import React from 'react';
import { ComposedChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, LabelList, ResponsiveContainer } from 'recharts';
import { formatNumberWithCommas } from '../../../utils/utils';


const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', background: '#fff', padding: 10 }}>
                <div >{`${payload[0]['payload']['name']}`}</div>
                <div style={{ color: "#33ABDA" }}>Local Count: {`${formatNumberWithCommas(payload[0]['payload']['hoverLocalDisplay'])}`}</div>
                <div style={{ color: "#B05788" }}>Global Count: {`${formatNumberWithCommas(payload[0]['payload']['hoverGlobalDisplay'])}`}</div>
                {/* <div style={{ color: "#0078A7" }}>Total Count: {`${(payload[0]['payload']['amt']).toFixed(2)}`}</div> */}
            </div>
        );
    }

    return null;
};

const VeridionStackedChart = React.memo(({ inputData=[], chartKey="supplierName" }) => {

    const data = inputData.map(item => ({
        supplierName: item.bu,
        localPercent: item.localPercent.toString(),
        localPercentDisplay: `${item.localPercent}%`,
        globalPercent: item.globalPercent.toString(),
        globalPercentDisplay: `${item.globalPercent}%`,
        hoverLocalDisplay: item.localCount.toString(),
        hoverGlobalDisplay: item.globalCount.toString()
      }));
    function formatData(input, chartKey) {
        if (input !== undefined) {
            return input
                .map(item => {
                    const localPercent = parseFloat(item.localPercent);
                    const globalPercent = parseFloat(item.globalPercent);
                    const totalSpend = localPercent + globalPercent;

                    return {
                        name: item[chartKey], // Use chartKey as the 'name'
                        localCount: localPercent, // Round off 'localCount' to nearest integer
                        globalCount: globalPercent, // Round off 'globalCount' to nearest integer
                        localCountDisplay: item.localPercentDisplay, // Round off 'localCount' to nearest integer
                        globalCountDisplay: item.globalPercentDisplay, // Round off 'globalCount' to nearest integer
                        hoverLocalDisplay: item.hoverLocalDisplay,
                        hoverGlobalDisplay: item.hoverGlobalDisplay,
                        amt: totalSpend // Round off total spend
                    };
                })
                ?.sort((a, b) => b?.amt - a?.amt);
        }
    }
    const generateTicks = (min, max) => {
        const range = max - min;
        const step = Math.ceil(range / 5);
        return Array.from({ length: 6 }, (_, i) => min + i * step);
    };

    const spendByTopSupplier = formatData(data, chartKey);
    const enhancedData = spendByTopSupplier && spendByTopSupplier.map((item) => ({
        ...item,
        total: item.globalCount + item.localCount,
    }));

    const barSize = 40;
    const barSpacing = 60; // Space between bars
    let chartWidth = data.length * (barSize + barSpacing);

    if(chartWidth<1300) {
        chartWidth = 1300;
    }
    return (
        <div style={{ width: '100%', overflowX: 'auto', overflowY: 'hidden' }}>
        <div style={{ width: `${chartWidth}px`, height: '400px' }}>
        {/*  <div style={{ width: "100%", height: "400px", overflowY: "auto" }}>
             <div style={{ width: '100%', height: `${data.length * 50}px` }}> */}
                {/* <ResponsiveContainer width="100%" height="100%" minHeight="120px">
                    <ComposedChart
                        layout="vertical"
                        data={enhancedData}
                        margin={{
                            top: 20,
                            right: 70,
                            bottom: 20,
                            left: 35,
                        }}
                    >
                        <CartesianGrid horizontal={false} />
                        <XAxis type="number" axisLine={false} tickLine={false}
                            domain={[
                                Math.min(0, ...enhancedData.map(item => Math.floor(item.total / 100) * 100)),
                                Math.max(...enhancedData.map(item => Math.ceil(item.total / 100) * 100)),
                            ]}
                            ticks={(() => {
                                const min = Math.min(0, ...enhancedData.map(item => Math.floor(item.total / 100) * 100));
                                const max = Math.max(...enhancedData.map(item => Math.ceil(item.total / 100) * 100));
                                return generateTicks(min, max);
                            })()}
                        />
                        <YAxis dataKey="name" tick={{ fontSize: 10, fontWeight: 'bold' }} type="category" axisLine={false} tickLine={false} />
                        <Bar dataKey="localCount" stackId="a" barSize={20} fill="#33ABDA" />
                        <Bar dataKey="globalCount" stackId="a" barSize={20} fill="#B05788"/>
                        {/* <Bar dataKey="amt" stackId="a" barSize={20} fill="#0078A7" >
                            <LabelList dataKey="total" position="right" content={renderTotalLabel} />
                        </Bar> 
                        <Tooltip content={<CustomTooltip />} />
                    </ComposedChart>
                </ResponsiveContainer> */}
                <ResponsiveContainer width="100%" height="100%">
                    <ComposedChart
                        data={enhancedData}
                        margin={{
                            top: 20,
                            right: 20,
                            bottom: 20,
                            left: 20,
                        }}
                    >
                        <CartesianGrid vertical={false} />
                        <XAxis 
                            dataKey="name" 
                            type="category" 
                            tick={{ fontSize: 10, fontWeight: 'bold' }} 
                            axisLine={false} 
                            tickLine={false} 
                        />
                        <YAxis 
                            type="number" 
                            axisLine={false} 
                            tickLine={false} 
                            domain={[
                                0,
                                125
                                // Math.max(...enhancedData.map(item => Math.ceil(item.total / 100) * 100)),
                            ]}
                            ticks={(() => {
                                const max = 125;// Math.max(...enhancedData.map(item => Math.ceil(item.total / 100) * 100));
                                return generateTicks(0, max);
                            })()}
                            tickFormatter={(value) => `${value}%`}
                            label={{
                                value: 'Global vs Local Supplier distribution',
                                angle: -90,
                                position: 'insideLeft',
                                offset: 2,
                                style: { textAnchor: 'middle', fontSize: "16px", fontWeight: "700", fill: "#616161", fontFamily: 'Inter', },
                            }}
                        />
                        <Bar dataKey="localCount" stackId="a" fill="#33ABDA" barSize={barSize} >
                             <LabelList dataKey="localCountDisplay" position="insideMiddle" fill="#fff" fontSize={10} />
                        </Bar>
                        <Bar dataKey="globalCount" stackId="a" fill="#B05788" barSize={barSize}>
                             <LabelList dataKey="globalCountDisplay" position="insideMiddle" fill="#fff" fontSize={10} />
                        </Bar>
                        <Tooltip content={<CustomTooltip />} cursor={false} />
                    </ComposedChart>
                </ResponsiveContainer>

            </div>
        </div>
    );
});

export default VeridionStackedChart;
